import { Link } from "react-router-dom";
import styled, { CSSProperties } from "styled-components";
import themeProps from "theme/themes";

interface ButtonLinkProps {
  label: string;
  color?: string;
  onClick?: any;
  filled?: boolean;
  styles?: CSSProperties;
  to: string;
}

const StyledLinkFilled = styled(Link)`
  background-color: ${(props: any) =>
    props.color ? props.color : props.theme.button.primary.normal};
  color: #fff;
  padding: 10px 0;
  width: 100%;
  border: none;
  border-radius: ${(props) => props.theme.common.borderRadius};
  outline: none;
  text-decoration: none;
  font-size: 1.3rem;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  &:hover {
    background-color: ${(props: any) =>
      props.color ? props.color : props.theme.button.primary.hover};
  }
`;

const StyledLink = styled(StyledLinkFilled)`
  background-color: ${(props: themeProps) =>
    props.theme.button.secondary.normal};
  color: ${(props: themeProps) => props.theme.button.secondary.text};
  border: 1px solid ${(props: themeProps) => props.theme.button.secondary.text};
  &:hover {
    background-color: ${(props: any) =>
      props.color ? props.color : props.theme.button.secondary.hover};
    border: 1px solid
      ${(props: themeProps) => props.theme.button.secondary.hover};
    color: ${(props: themeProps) => props.theme.button.secondary.textHover};
  }
`;

const ButtonLink = ({ label, color, styles, filled, to }: ButtonLinkProps) => {
  return filled ? (
    <StyledLinkFilled style={styles} color={color} to={to}>
      {label}
    </StyledLinkFilled>
  ) : (
    <StyledLink style={styles} color={color} to={to}>
      {label}
    </StyledLink>
  );
};

export default ButtonLink;
